// import React from 'react';
import styled from 'styled-components';
import { themeGet, breakpoints as bp } from '@firsttable/web-theme';
import media from 'styled-media-query';
import Box from '../Box';

type SwitchType = {
  active: boolean;
  orientation: string;
};

const Switch = styled(Box)<SwitchType>`
  line-height: 34px;
  border-radius: 5px;
  border: 1px solid
    ${({ active }) =>
      active ? themeGet('colors.grayscale.300') : 'transparent'};
  cursor: pointer;
  width: 50%;
  text-align: center;
  position: absolute;
  user-select: none;
  background-color: ${({ active }) =>
    active ? themeGet('colors.white') : 'transparent'};
  color: ${themeGet('colors.brand.blue')};
  left: ${({ active, orientation }) => {
    if (orientation === 'left') {
      return active ? '-1px' : 0;
    }
    return 'auto';
  }};
  right: ${({ active, orientation }) => {
    if (orientation === 'right') {
      return active ? '-1px' : 0;
    }
    return 'auto';
  }};
  margin-left: ${({ active, orientation }) => {
    if (orientation === 'left') {
      return active ? '0' : '-1px';
    }
    return 'auto';
  }};
  margin-right: ${({ active, orientation }) => {
    if (orientation === 'right') {
      return active ? '0' : '-1px';
    }
    return 'auto';
  }};
  font-weight: 600;
  padding: ${({ active }) => (active ? '1px ' : '0 ')} 20px;
  top: ${({ active }) => (active ? '-1px' : 0)};
  bottom: ${({ active }) => (active ? '-1px' : 0)};
`;

export default Switch;
